
import nacionalesBus from './nacionalesBus.jpeg';
import nacionalesAereo from './nacionalesAereo.jpeg';
import internacionales from './internacionales.jpeg';
import grupales from './grupales.jpeg';

const categories = [
    {
        "title": "DESTINOS NACIONALES \nBUS",
        "image": nacionalesBus,
        "category": "Nacional Bus"
    },
    {
        "title": "DESTINOS NACIONALES \nAEREO",
        "image": nacionalesAereo,
        "category": "Nacional Aereo"
    },
    {
        "title": "SALIDAS INTERNACIONALES",
        "image": internacionales,
        "category": "Internacional"
    },
    {
        "title": "SALIDAS GRUPALES",
        "image": grupales,
        "category": "Grupal"
    }
];

export default categories;
